/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListActivities200ResponseDataInner
 */
export interface ListActivities200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof ListActivities200ResponseDataInner
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ListActivities200ResponseDataInner
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof ListActivities200ResponseDataInner
     */
    carId?: number;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    typeLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    lat?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    lng?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    scheduledAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListActivities200ResponseDataInner
     */
    isPublic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseDataInner
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ListActivities200ResponseDataInner interface.
 */
export function instanceOfListActivities200ResponseDataInner(value: object): value is ListActivities200ResponseDataInner {
    return true;
}

export function ListActivities200ResponseDataInnerFromJSON(json: any): ListActivities200ResponseDataInner {
    return ListActivities200ResponseDataInnerFromJSONTyped(json, false);
}

export function ListActivities200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListActivities200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'carId': json['car_id'] == null ? undefined : json['car_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeLabel': json['type_label'] == null ? undefined : json['type_label'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'scheduledAt': json['scheduled_at'] == null ? undefined : json['scheduled_at'],
        'isPublic': json['is_public'] == null ? undefined : json['is_public'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ListActivities200ResponseDataInnerToJSON(json: any): ListActivities200ResponseDataInner {
    return ListActivities200ResponseDataInnerToJSONTyped(json, false);
}

export function ListActivities200ResponseDataInnerToJSONTyped(value?: ListActivities200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'car_id': value['carId'],
        'type': value['type'],
        'type_label': value['typeLabel'],
        'summary': value['summary'],
        'location_name': value['locationName'],
        'lat': value['lat'],
        'lng': value['lng'],
        'scheduled_at': value['scheduledAt'],
        'is_public': value['isPublic'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

